module.exports = __webpack_public_path__ + "static/media/HowItWorks.49ca22ed.png";